// printDisplayText — what a blueprint `print` node puts on the screen.
//
// Extracted from EventRuntime's print case so the rule is unit-testable:
// EventRuntime itself uses extensionless imports (Vite resolves them, node does
// not), so nothing in it can be driven from tests/unit. The rule is small and
// it is the thing that actually failed in front of a user, so it gets to live
// somewhere a test can reach it.
//
// The rule: a payload may name its own display string via `message`, and when
// it does that string wins over the raw JSON. This is a convention, not a
// special case for one event — an event that knows how to describe itself to a
// user should not be shown as its own wire format.
//
// It exists because the WS-disconnect toast read `{"code":1006,"reason":""}` on
// gass: every shipped blueprint wires ev_ws_disconnected -> act_print_disconnect
// with no `text`, so the print node walked up to the onWSDisconnected payload
// and stringified it. 1006 means "no close frame received" and therefore never
// carries a reason, so the one field that could have meant something is empty
// exactly when it fires. See wsCloseMessage.js for the sentence itself.
//
// Callers keep logging the FULL object to the console — this only decides the
// on-screen headline, so `code` moves out of it rather than disappearing.

/**
 * @param {unknown} value  the resolved print value (pin, typed text, or the
 *                         walked-up event payload)
 * @returns {string} text safe to render as-is
 */
export function printDisplayText(value) {
  if (typeof value === 'object' && value !== null) {
    const m = value.message
    if (typeof m === 'string' && m.trim()) return m
    // Arrays and plain data have no self-description; the JSON is the point.
    return JSON.stringify(value)
  }
  return String(value)
}
